import { Field, Label, Switch } from '@headlessui/react'
import { Text } from '~/components/typography'
import { cn } from '~/util'

export type ToggleSwitchProps = {
  checked: boolean
  onChange: (checked: boolean) => void
  fill?: boolean
  left: string
  right: string
  containerClassName?: string
  labelClassName?: string
  switchClassName?: string
  buttonClassName?: string
  level?: 1 | 2 | 3 | 4 | 5
  disabled?: boolean
}

export default function ToggleSwitch({
  checked,
  onChange,
  disabled,
  left,
  right,
  containerClassName,
  labelClassName,
  switchClassName,
  buttonClassName,
  level = 3,
}: ToggleSwitchProps) {
  return (
    <Field disabled={disabled} className={cn('flex items-center gap-1', containerClassName)}>
      <Label>
        <Text
          level={level}
          className={cn(
            'font-semibold text-neutral-midfi-grey',
            disabled ? 'opacity-50' : '',
            labelClassName
          )}
        >
          {left}
        </Text>
      </Label>
      <Switch
        checked={checked}
        onChange={onChange}
        className={cn(
          'group relative inline-flex h-6 w-12 shrink-0 cursor-pointer rounded-full border-2 border-neutral-midfi-grey bg-neutral-white transition-colors duration-200 ease-in-out focus:outline-none',
          disabled ? 'cursor-not-allowed opacity-50' : '',
          switchClassName
        )}
      >
        <span
          className={cn(
            'pointer-events-none inline-block h-4 w-4 translate-x-0.5 translate-y-[2px] transform rounded-full bg-neutral-midfi-grey shadow-sm ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-[26px]',
            buttonClassName
          )}
        />
      </Switch>
      <Label>
        <Text
          level={level}
          className={cn(
            'font-semibold text-neutral-midfi-grey',
            disabled ? 'opacity-50' : '',
            labelClassName
          )}
        >
          {right}
        </Text>
      </Label>
    </Field>
  )
}
